import { connect } from 'react-redux';
import lifecycle from 'recompose/lifecycle';

import { fetchLocalization } from './actions';
import CustomIntlProviderComponent from './CustomIntlProvider';

export const mapStateToProps = state => {
  const { locale, messages } = state.localizationArea;
  const culture =
    (state.journeyBuilderUIDataArea.userData.hasValue &&
      state.journeyBuilderUIDataArea.userData.value.userDetails.locale.localeCode) ||
    'en-US';
  return { locale, messages, culture };
};

const mapDispatchToProps = {
  fetchLocalization,
};

export const enhance = lifecycle({
  componentDidMount() {
    const { culture, fetchLocalization } = this.props;
    if (culture) {
      fetchLocalization(culture);
    }
  },
  componentDidUpdate(prevProps) {
    const { culture, fetchLocalization } = this.props;
    if (culture && culture !== prevProps.culture) {
      fetchLocalization(culture);
    }
  },
})(CustomIntlProviderComponent);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(enhance);



// WEBPACK FOOTER //
// ./src/Shared/CustomIntlProvider/index.js